import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Divider, Tooltip } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { tooltipClasses } from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import MainDrawer from "Drawers/MainDrawer.js";
import APIRequest from "Helpers/ApiRequest.js";
import AppIcon from "Helpers/AppIcon";
import { useSnackbar } from "notistack";
import * as React from "react";
import { Link, useSearchParams } from "react-router-dom";
import Cookies from "universal-cookie";
import VirtualizedList from "Helpers/VirtList";
import { ScopeMap } from "Helpers/Scopes";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const cookies = new Cookies();

function Capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export default function SignIn(props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [remember, setRemember] = React.useState(false);
  const [requestedActions, setRequestedActions] = React.useState();
  const areAllFieldsFilled = email != "" && password != "";
  const [open, setOpen] = React.useState(false);
  const desktopTooltip = "Download a Desktop Version of the app";
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [oAuthValid, setOAuthValid] = React.useState(false);
  const [showInvalidOAuth, setShowInvalidOAuth] = React.useState(false);
  const [oAuthOpen, setOAuthOpen] = React.useState(false);
  const [pageType, setPageType] = React.useState("login");
  const [oAuthDetails, setOAuthDetails] = React.useState({
    name: "",
    email: "",
    website: "",
  });
  const scopeMap = ScopeMap;
  const [isOAuth, setIsOAuth] = React.useState(
    Object.fromEntries([...searchParams])["client_id"]
  );

  React.useEffect(() => {
    if (localStorage.getItem("remember")) {
      setRemember(localStorage.getItem("remember") === "true" ? true : false);
    }

    if (Object.fromEntries([...searchParams])["client_id"]) {
      if (
        Object.fromEntries([...searchParams])["client_id"] ===
        "2heZb6TYHzb9ksq6ChepVZunbTCkbBd4"
      ) {
        setPageType("backpack");
      } else {
        setPageType("oauth");
      }
    }

    const handleOAuth = async () => {
      if (!searchParams.get("client_id")) {
        setShowInvalidOAuth(false);
      }
      if (
        params["oauth2"] == 1 &&
        params["client_id"] &&
        params["scope"] &&
        params["state"] &&
        params["response_type"]
      ) {
        var oAuthReq = await APIRequest({
          action: "oauth2_get_client_info",
          client_id: params["client_id"],
          scope: params["scope"],
          state: params["state"],
          response_type: params["response_type"],
          ...(params["redirect_uri"]
            ? { redirect_uri: params["redirect_uri"] }
            : {}),
        });
        if (oAuthReq.status == true) {
          setOAuthDetails({
            name: oAuthReq.data.name,
            email: oAuthReq.data.contact_email,
            website: oAuthReq.data.website,
          });
          var scopes = params["scope"].split(" ");
          var scopesList = [];
          scopes.forEach((x) =>
            scopeMap[x]
              ? scopesList.push({
                  title: Capitalize(x),
                  data: scopeMap[x].data,
                  icon: scopeMap[x].icon,
                })
              : scopesList.push({
                  title: Capitalize(x),
                  data: "",
                  icon: "star",
                })
          );
          setRequestedActions(scopesList);
          setOAuthValid(true);
          handleOAuthOpen();
        } else {
          enqueueSnackbar(oAuthReq.message, {
            variant: "error",
            preventDuplicate: true,
          });
          setOAuthValid(false);
          setShowInvalidOAuth(true);
          handleOAuthClose();
        }
      }
    };
    handleOAuth();
    if (localStorage.getItem("remember") === "true") {
      if (localStorage.getItem("email")) {
        setEmail(localStorage.getItem("email"));
      }
    }
  }, []);

  const handleOAuthOpen = () => {
    setOAuthOpen(true);
  };

  const handleOAuthClose = () => {
    setOAuthOpen(false);
  };

  const handlePlc = async () => {
    var req = await APIRequest({
      action: "is_external_login_complete",
      cookie_id: params["plc"],
    });
    if (req.status == true && params["plc"] != "test") {
      window.location.replace(window.location.origin + "/login");
    }
  };

  React.useEffect(() => {
    if (remember) {
      localStorage.setItem("email", email);
    }
  }, [email]);

  const handleClose = () => {
    setOpen(false);
  };
  const OpenBackground = () => {
    setOpen(true);
  };

  const params = Object.fromEntries([...searchParams]);
  var loc = window.location.search;

  const handleRemember = (event) => {
    setRemember(event.target.checked);
    localStorage.setItem("remember", event.target.checked);
  };

  if (params["plc"] && !open) {
    handlePlc();
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    var body = await APIRequest({
      action: "login",
      email: data.get("email"),
      password: data.get("password"),
      ...(params["plc"] ? { external_login: params["plc"] } : {}),
      ...(oAuthValid
        ? {
            client_id: params["client_id"],
            scope: params["scope"],
            state: params["state"],
            response_type: params["response_type"],
          }
        : {}),
      ...(params["redirect_uri"]
        ? { redirect_uri: params["redirect_uri"] }
        : {}),
    });

    if (body.status == true) {
      var userID = body.data.account_id;
      var cookieID = body.data.cookie_id;
      var firstName = body.data.firstname;
      var lastName = body.data.lastname;
      cookies.set("user", userID, { path: "/", secure: true, sameSite: "Lax" });
      cookies.set("cookie", cookieID, {
        path: "/",
        secure: true,
        sameSite: "Lax",
      });
      cookies.set("firstname", firstName, {
        path: "/",
        secure: true,
        sameSite: "Lax",
      });
      cookies.set("lastname", lastName, {
        path: "/",
        secure: true,
        sameSite: "Lax",
      });
      if (body.data.auth_code && body.data.redirect_uri) {
        enqueueSnackbar(`Successfully Linked Account`, { variant: "success" });

        window.location.replace(body.data.redirect_uri);
      } else {
        enqueueSnackbar(
          `Sign-in Successful${
            params["plc"]
              ? params["plc"].length > 0
                ? ", Continue On Client"
                : ", Sending To Conectado"
              : ""
          }`,
          { variant: "success" }
        );
        if (params["plc"]?.length > 0) {
          setOpen(true);
        } else {
          window.location.replace(
            (process.env.REACT_APP_SITE_URL || '') + "/stream/" + encodeURI(cookieID)
          );
        }
      }
    } else {
      enqueueSnackbar(body.message, {
        variant: "error",
        preventDuplicate: true,
      });
    }
  };

  const [forgotOpen, setForgotOpen] = React.useState(false);

  const handleForgotPassword = () => {
    setForgotOpen(true);
  };

  const handleForgotPasswordClose = () => {
    setForgotOpen(false);
  };

  const sendForgotEmail = async (event) => {
    event.preventDefault();
    var body = await APIRequest({ action: "password_forget", email: email });
    if (body.status == true) {
      enqueueSnackbar(body.message, {
        variant: "success",
        preventDuplicate: true,
      });
    } else {
      enqueueSnackbar(body.message, {
        variant: "error",
        preventDuplicate: true,
      });
    }
    setForgotOpen(false);
  };

  return (
    <Box>
      {pageType !== "backpack" && <MainDrawer />}
      {!showInvalidOAuth && (
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Box
            sx={{
              marginTop: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              ...(pageType === "backpack" ? { marginTop: "3rem" } : {}),
            }}
            backgroundColor="background.paper"
          >
            <AppIcon/>
            {pageType === "login" && (
              <Typography
                component="h1"
                variant="h5"
                sx={{
                  textAlign: "center",
                }}
              >
                Sign in to Conectado
              </Typography>
            )}
            {pageType === "backpack" && (
              <div>
                <Typography
                  component="h1"
                  variant="h5"
                  sx={{
                    textAlign: "center",
                    ...(pageType === "backpack" ? { fontSize: "1.35rem" } : {}),
                  }}
                >
                  Login to the Conectado Ecosystem
                </Typography>
                <Typography
                  component="h2"
                  variant="h6"
                  sx={{
                    textAlign: "center",
                    fontSize: "0.8rem",
                  }}
                >
                  Access the AI Opportunity Backpack and the Conectadoverse
                </Typography>
              </div>
            )}
            {pageType === "oauth" && (
              <div>
                {oAuthDetails?.website && (
                  <Typography
                    component="h1"
                    variant="h5"
                    sx={{
                      textAlign: "center",
                    }}
                  >
                    Login to the Conectado Ecosystem
                  </Typography>
                )}
                {oAuthDetails?.website && (
                  <Typography
                    component="h2"
                    variant="h6"
                    sx={{
                      textAlign: "center",
                      ...(oAuthDetails?.website
                        ? { marginBottom: "0px" }
                        : { marginBottom: "1rem" }),
                    }}
                  >
                    {`Authori${
                      (navigator?.language || navigator?.userLanguage) ===
                      "en-GB"
                        ? "s"
                        : "z"
                    }ation Request`}
                  </Typography>
                )}
                {oAuthDetails?.name && (
                  <Tooltip
                    arrow
                    describeChild
                    title={
                      oAuthDetails?.email && (
                        <React.Fragment>
                          <Typography
                            color="inherit"
                            sx={{ fontWeight: 700, fontSize: 12 }}
                          >
                            Contact
                          </Typography>
                          <Typography
                            component={Link}
                            to={`mailto:` + oAuthDetails?.email}
                            target="_blank"
                            rel="noopener noreferrer"
                            color="inherit"
                            sx={{ textDecoration: "none", fontSize: 14 }}
                          >
                            {oAuthDetails?.email}
                          </Typography>
                        </React.Fragment>
                      )
                    }
                  >
                    <Typography
                      component={oAuthDetails?.website ? Link : "h1"}
                      to={oAuthDetails?.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        textAlign: "center",
                        textDecoration: "none",
                        fontSize: "11px",
                        color: "text.secondary",
                        textAlign: "center",
                        marginBottom: "1rem",
                        
                      }}
                    >
                      {oAuthDetails?.name} is requesting access to your
                      Conectado account
                    </Typography>
                  </Tooltip>
                )}
                {oAuthValid && (
                  <VirtualizedList
                    width={"100%"}
                    height={200}
                    itemSize={80}
                    items={requestedActions}
                  />
                )}
              </div>
            )}

            <Box
              component="form"
              id="loginForm"
              onSubmit={handleSubmit}
              noValidate
              sx={{
                width: "100%",
                ...(pageType === "backpack"
                  ? { mt: "0.2rem" }
                  : { mt: "1rem" }),
              }}
            >
              <Typography
                component="h3"
                variant="h6"
                sx={{ marginTop: "1rem" }}
              >
                Email
              </Typography>

              <TextField
                margin="none"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                autoFocus
                variant="filled"
                InputProps={{
                  disableUnderline: true,
                  sx: {
                    borderRadius: "15px",
                    "& input": { paddingLeft: 2 },
                    "& .MuiFilledInput-input:autofill": {
                      boxShadow: 0,
                      borderRadius: "inherit",
                    },
                    "& .MuiInputBase-root": {
                      backgroundColor: "background.paper",
                    },
                  },
                }}
              />
              <Typography
                component="h3"
                variant="h6"
                sx={{ marginTop: "1rem" }}
              >
                Password
              </Typography>
              <TextField
                margin="none"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="password"
                variant="filled"
                InputProps={{
                  disableUnderline: true,
                  sx: {
                    borderRadius: "15px",
                    "& input": { paddingLeft: 2 },
                    "& .MuiFilledInput-input:autofill": {
                      boxShadow: 0,
                      borderRadius: "inherit",
                    },
                    "& .MuiInputBase-root": {
                      backgroundColor: "background.paper",
                    },
                  },
                }}
              />

              <Grid
                container
                alignItems="center"
                justifyContent="center"
                sx={{ marginTop: "1rem" }}
              >
                <Grid item xs>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={remember}
                        color="primary"
                        onChange={handleRemember}
                      />
                    }
                    label={
                      <Typography variant="option">Remember me</Typography>
                    }
                  />
                </Grid>
                <Grid item>
                  {pageType !== "backpack" && (
                    <Tooltip title={desktopTooltip}>
                      <Typography
                        component={Link}
                        to="/desktop"
                        variant="option"
                        sx={{
                          textDecoration: "none",
                          fontWeight: 600,
                          color: "primary.main",
                        }}
                      >
                        Desktop Version
                      </Typography>
                    </Tooltip>
                  )}
                </Grid>
              </Grid>
              <Divider sx={{ marginTop: "1rem" }}></Divider>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={!areAllFieldsFilled}
                endIcon={<ArrowForwardIcon />}
                sx={{ mt: 3, mb: 2 }}
              >
                {oAuthValid && pageType === "oauth"
                  ? "Log In and Authorize"
                  : "Log In"}
              </Button>
              <Typography
                variant="body2"
                textAlign="center"
                sx={{
                  color: "text.secondary",
                  align: "center",
                  fontWeight: 600,
                }}
              >
                Forgot your password?{" "}
                {
                  <Typography
                    component={Button}
                    onClick={handleForgotPassword}
                    variant="text"
                    color="primary"
                    size="small"
                    sx={{ textDecoration: "none" }}
                  >
                    Reset Password
                  </Typography>
                }
              </Typography>
              <Dialog
                open={forgotOpen}
                onClose={handleForgotPasswordClose}
                fullWidth={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  {"Reset Password"}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Enter your email to reset password
                  </DialogContentText>
                  <Typography
                    component="h3"
                    variant="h6"
                    sx={{ marginTop: "1rem" }}
                  >
                    Email
                  </Typography>

                  <TextField
                    margin="none"
                    required
                    fullWidth
                    id="email"
                    label="Email Address"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                    autoFocus
                    variant="filled"
                    InputProps={{
                      disableUnderline: true,
                      sx: {
                        borderRadius: "15px",
                        "& input": { paddingLeft: 2 },
                        "& .MuiFilledInput-input:autofill": {
                          boxShadow: 0,
                          borderRadius: "inherit",
                        },
                        "& .MuiInputBase-root": {
                          backgroundColor: "background.paper",
                        },
                      },
                    }}
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleForgotPasswordClose}>Cancel</Button>
                  <Button onClick={sendForgotEmail} autoFocus>
                    Send
                  </Button>
                </DialogActions>
              </Dialog>
              <Typography
                variant="body2"
                textAlign="center"
                sx={{
                  color: "text.secondary",
                  align: "center",
                  fontWeight: 600,
                }}
              >
                Don't have an account?{" "}
                {
                  <Typography
                    component={Link}
                    to={`/register${loc}`}
                    variant="contained"
                    color="primary"
                    sx={{ textDecoration: "none" }}
                  >
                    Register
                  </Typography>
                }
              </Typography>
            </Box>
          </Box>
          {email == "meet" && (
            <Typography
              component={Link}
              to="/meet"
              variant="option"
              sx={{
                textDecoration: "none",
                fontWeight: 600,
                color: "primary.main",
              }}
            >
              Temp Testing
            </Typography>
          )}
        </Container>
      )}
      {showInvalidOAuth && (
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Box
            sx={{
              marginTop: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <AppIcon />
            <Typography
              component="h1"
              variant="h5"
              sx={{
                textAlign: "center",
                ...(oAuthDetails?.website
                  ? { marginBottom: "0px" }
                  : { marginBottom: "1rem" }),
              }}
            >
              You have been incorrectly directed to this page
            </Typography>
          </Box>
        </Container>
      )}
      <Backdrop
        sx={{
          backgroundColor: "background.paper",
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={open}
        onClick={handleClose}
      >
        <Box
          sx={{
            width: 500,
            height: 700,
            borderRadius: 8,
            bgcolor: "background.paper",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderTop: 220,
            borderColor: "background.paper",
          }}
        >
          <AppIcon />
          <Typography
            component="h1"
            variant="h4"
            fontWeight={800}
            sx={{ marginBottom: ".5rem" }}
          >
            Welcome {cookies.get("firstname")}
          </Typography>
          {params["plc"] != null && (
            <Typography
              component="h1"
              variant="h5"
              fontWeight={500}
              sx={{ marginBottom: "1rem" }}
            >
              Please Continue On Client
            </Typography>
          )}
        </Box>
      </Backdrop>
    </Box>
  );
}
